import { render, staticRenderFns } from "./ProductTypeFilter.vue?vue&type=template&id=5dc73da2&"
import script from "./ProductTypeFilter.vue?vue&type=script&lang=js&"
export * from "./ProductTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports